module.exports = __webpack_public_path__ + "assets/94347f441d7bdd6fc8960e84d47e8ecd.mp3";